import React from "react";
// import "./Copyright.scss";

export default function Copyright() {
	return (
		<div className="copyright text-center py-4 bg-gray-800 text-white absolute bottom-0 w-[100%]">
			Copyright (2024)
		</div>
	);
}
